import styled from 'styled-components'
import { Button } from '~/styles/global'
import { breakpoints } from '../../styles/global'

const transition = {
  duration: '0.5s',
}

export const Modal = styled.div`
  position: fixed;
  z-index: 5;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  visibility: ${props => (props.open ? 'visible' : 'hidden')};
`

export const Drawer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 7;
  background: white;
  right: 0;
  top: 0;
  width: 75%;
  height: 100%;
  max-height: 100%;
  padding: 25px;
  transition-property: ${props => (props.open ? `transform` : `transform, visibility`)};
  transition-duration: ${transition.duration};

  visibility: ${props => (props.open ? 'visible' : 'hidden')};
  transform: ${props => (props.open ? 'translate3d(0, 0, 0)' : 'translate3d(100%, 0, 0)')};

  @media (min-width: ${breakpoints.min.laptop}px) {
    width: 33.333%;
  }
`

export const Backdrop = styled.div`
  position: absolute;
  z-index: 6;
  width: 100%;
  height: 100%;
  background-color: #0000002e;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`

export const HeaderTitle = styled.h2`
  margin: 0;
`

export const CloseButton = styled.button`
  padding: 0;
  margin: 0;
  background: none;
  outline: none;
  border: unset;
  cursor: pointer;

  & svg {
    width: 1.25em;
    height: 1.25em;
  }
`

export const CloseIcon = styled.img`
  width: 1.25em;
  height: 1.25em;
`

export const LineItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: scroll;
`

export const CheckoutButton = styled(Button)`
  ${'' /* background-color: #4ba13d; */}
  background-color: black;
  margin-bottom: 0;
`

export const CartFooter = styled.div``

export const SubTotalContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Divider = styled.hr`
  width: 100%;
  border: 1px solid #dbdbdc;
  margin: 0.75rem 0;
`
